<template lang="pug">
div
  h1.title {{ checkEstado('pa') ? 'Mapa de Áreas sob Jurisdição do ITERPA' : 'Mapa'}}
  app-consulta-mapa(:processos="processos")
  h1.title(v-if="isPa") Dados de Monitoramento de Cláusulas Resolutivas
  app-monitoramento-de-clausulas-resolutivas
  h1.title Relatórios
  app-consulta-relatorio
  h1.title Consulta e Espelho do Processo
  app-consulta(@changeProcessos="(processos) => this.processos = processos")
</template>
<script>
import AppConsulta from '@/screens/portal/publico/components/Consulta'
import AppConsultaMapa from '@/screens/portal/publico/components/ConsultaMapa'
import AppConsultaRelatorio from '@/screens/portal/publico/components/ConsultaRelatorio'
import AppMonitoramentoDeClausulasResolutivas from '@/screens/portal/publico/components/AppMonitoramentoDeClausulasResolutivas'

export default {

  data () {
    return {
      processos: [],
      isPa: process.env.ESTADO === 'pa'
    }
  },

  components: {
    AppConsulta,
    AppConsultaMapa,
    AppConsultaRelatorio,
    AppMonitoramentoDeClausulasResolutivas
  },

  methods: {
    checkEstado (estado) {
      return process.env.ESTADO === estado
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_variables.scss';

.title {
  color: $color-primary;
}

.main {
  color: $font-color;
  text-align: left;
  padding: 0 10% 0 10%;
  margin-bottom: 20px;
}

</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/Transparencia.vue